import DOMPurify from 'dompurify';
export const cleanContent = (value) => {
    return DOMPurify.sanitize(value, {
        FORBID_TAGS: ['iframe', 'script'],
        FORBID_ATTR: ['srcdoc', 'onerror', 'onclick', 'onload'],
    });
};
